<template>
  <v-row :dense="$vuetify.breakpoint.mobile">
    <v-col cols="12" sm="6" v-for="shopData in data" :key="shopData.shopCode">
      <ShopStatisticCard :shop-statistic="shopData" :comparison-shop-statistic="comparisonForShop(shopData.shopCode)" />
    </v-col>
  </v-row>
</template>

<script>
import ShopStatisticCard from "@/components/Statistics/StatisticByShops/ShopStatisticCard";
export default {
  name: "StatisticByShops",
  components: {ShopStatisticCard},
  props: {
    data: {
      type: Array,
    },
    comparisonData: {
      type: Array,
      default: null,
    },
  },
  methods: {
    comparisonForShop(shopCode) {
      if (!this.comparisonData) return null;
      return this.comparisonData.find((shop) => shop.shopCode === shopCode) || null;
    },
  }
}
</script>

<style scoped>

</style>
